export const createAction = (type: string) => {
  const actionCreator = (payload?: unknown) => ({ type, payload });
  actionCreator.toString = () => type;
  return actionCreator;
};

export const CREATE_VACANCY_REQUESTED = 'CREATE_VACANCY_REQUESTED';
export const CREATE_VACANCY_RECEIVED = 'CREATE_VACANCY_RECEIVED';
export const CREATE_VACANCY_REJECTED = 'CREATE_VACANCY_REJECTED';

export const GET_CITY_REQUESTED = 'GET_CITY_REQUESTED';
export const GET_CITY_RECEIVED = 'GET_CITY_RECEIVED';
export const GET_CITY_REJECTED = 'GET_CITY_REJECTED';

export const GET_ROLE_REQUESTED = 'GET_ROLE_REQUESTED';
export const GET_ROLE_RECEIVED = 'GET_ROLE_RECEIVED';
export const GET_ROLE_REJECTED = 'GET_ROLE_REJECTED';

export const GET_RESPONSIBLE_USER_REQUESTED = 'GET_RESPONSIBLE_USER_REQUESTED';
export const GET_RESPONSIBLE_USER_RECEIVED = 'GET_RESPONSIBLE_USER_RECEIVED';
export const GET_RESPONSIBLE_USER_REJECTED = 'GET_RESPONSIBLE_USER_REJECTED';

export const VACANCY_GROUPS_REQUESTED = 'VACANCY_GROUPS_REQUESTED';
export const VACANCY_GROUPS_RECEIVED = 'VACANCY_GROUPS_RECEIVED';
export const VACANCY_GROUPS_REJECTED = 'VACANCY_GROUPS_REJECTED';

export const CREATE_VACANCY_GROUP_REQUESTED = 'CREATE_VACANCY_GROUP_REQUESTED';
export const CREATE_VACANCY_GROUP_RECEIVED = 'CREATE_VACANCY_GROUP_RECEIVED';
export const CREATE_VACANCY_GROUP_REJECTED = 'CREATE_VACANCY_GROUP_REJECTED';

export const EDIT_VACANCY_GROUP_REQUESTED = 'EDIT_VACANCY_GROUP_REQUESTED';
export const EDIT_VACANCY_GROUP_RECEIVED = 'EDIT_VACANCY_GROUP_RECEIVED';
export const EDIT_VACANCY_GROUP_REJECTED = 'EDIT_VACANCY_GROUP_REJECTED';

export const ADMIN_VACANCIES_REQUESTED = 'ADMIN_VACANCIES_REQUESTED';
export const ADMIN_VACANCIES_RECEIVED = 'ADMIN_VACANCIES_RECEIVED';
export const ADMIN_VACANCIES_REJECTED = 'ADMIN_VACANCIES_REJECTED';

export const OTHERS_VACANCIES_REQUESTED = 'OTHERS_VACANCIES_REQUESTED';
export const OTHERS_VACANCIES_REJECTED = 'OTHERS_VACANCIES_REJECTED';
export const OTHERS_VACANCIES_RECEIVED = 'OTHERS_VACANCIES_RECEIVED';

export const EDIT_VACANCY_REQUESTED = 'EDIT_VACANCY_REQUESTED';
export const EDIT_VACANCY_RECEIVED = 'EDIT_VACANCY_RECEIVED';
export const EDIT_VACANCY_REJECTED = 'EDIT_VACANCY_REJECTED';

export const DELETE_VACANCY_GROUP_REQUESTED = 'DELETE_VACANCY_GROUP_REQUESTED';
export const DELETE_VACANCY_GROUP_RECEIVED = 'DELETE_VACANCY_GROUP_RECEIVED';
export const DELETE_VACANCY_GROUP_REJECTED = 'DELETE_VACANCY_GROUP_REJECTED';

export const DELETE_VACANCY_REQUESTED = 'DELETE_VACANCY_GROUP_REQUESTED';
export const DELETE_VACANCY_RECEIVED = 'DELETE_VACANCY_RECEIVED';
export const DELETE_VACANCY_REJECTED = 'DELETE_VACANCY_REJECTED';

export const requestCreateVacancy = createAction(CREATE_VACANCY_REQUESTED);
export const receiveCreateVacancy = createAction(CREATE_VACANCY_RECEIVED);
export const rejectCreateVacancy = createAction(CREATE_VACANCY_REJECTED);

export const getResponsibleUserRequested = createAction(GET_RESPONSIBLE_USER_REQUESTED);
export const getResponsibleUserReceive = createAction(GET_RESPONSIBLE_USER_RECEIVED);
export const getResponsibleUserReject = createAction(GET_RESPONSIBLE_USER_REJECTED);

export const getCityRequested = createAction(GET_CITY_REQUESTED);
export const getCityReceive = createAction(GET_CITY_RECEIVED);
export const getCityReject = createAction(GET_CITY_REJECTED);

export const getRoleRequested = createAction(GET_ROLE_REQUESTED);
export const getRoleReceive = createAction(GET_ROLE_RECEIVED);
export const getRoleReject = createAction(GET_ROLE_REJECTED);

export const requestVacancyGroup = createAction(VACANCY_GROUPS_REQUESTED);
export const receiveVacancyGroup = createAction(VACANCY_GROUPS_RECEIVED);
export const rejectVacancyGroup = createAction(VACANCY_GROUPS_REJECTED);

export const requestCreateVacancyGroup = createAction(CREATE_VACANCY_GROUP_REQUESTED);
export const receiveCreateVacancyGroup = createAction(CREATE_VACANCY_GROUP_RECEIVED);
export const rejectCreateVacancyGroup = createAction(CREATE_VACANCY_GROUP_REJECTED);

export const requestEditVacancyGroup = createAction(EDIT_VACANCY_GROUP_REQUESTED);
export const receiveEditVacancyGroup = createAction(EDIT_VACANCY_GROUP_RECEIVED);
export const rejectEditVacancyGroup = createAction(EDIT_VACANCY_GROUP_REJECTED);

export const requestAdminVacancies = createAction(ADMIN_VACANCIES_REQUESTED);
export const receiveAdminVacancies = createAction(ADMIN_VACANCIES_RECEIVED);
export const rejectAdminVacancies = createAction(ADMIN_VACANCIES_REJECTED);

export const requestOthersVacancies = createAction(OTHERS_VACANCIES_REQUESTED);
export const receiveOthersVacancies = createAction(OTHERS_VACANCIES_RECEIVED);
export const rejectOthersVacancies = createAction(OTHERS_VACANCIES_REJECTED);

export const requestVacancyEdit = createAction(EDIT_VACANCY_REQUESTED);
export const receiveVacancyEdit = createAction(EDIT_VACANCY_GROUP_RECEIVED);
export const rejectVacancyEdit = createAction(EDIT_VACANCY_GROUP_REJECTED);

export const requestVacancyGroupDelete = createAction(DELETE_VACANCY_GROUP_REQUESTED);
export const receiveVacancyGroupDelete = createAction(DELETE_VACANCY_GROUP_RECEIVED);
export const rejectVacancyGroupDelete = createAction(DELETE_VACANCY_GROUP_REJECTED);

export const requestVacancyDelete = createAction(DELETE_VACANCY_REQUESTED);
export const receiveVacancyDelete = createAction(DELETE_VACANCY_RECEIVED);
export const rejectVacancyDelete = createAction(DELETE_VACANCY_REJECTED);

export const GET_DIVISION_REQUESTED = 'GET_DIVISION_REQUESTED';
export const GET_DIVISION_RECEIVED = 'GET_DIVISION_RECEIVED';
export const GET_DIVISION_REJECTED = 'GET_DIVISION_REJECTED';

export const getDivisionRequested = createAction(GET_DIVISION_REQUESTED);
export const getDivisionReceive = createAction(GET_DIVISION_RECEIVED);
export const getDivisionReject = createAction(GET_DIVISION_REJECTED);

export const GET_GROUPS_VACANCY_REQUESTED = 'GET_GROUPS_VACANCY_REQUESTED';
export const GET_GROUPS_VACANCY_RECEIVED = 'GET_GROUPS_VACANCY_RECEIVED';
export const GET_GROUPS_VACANCY_REJECTED = 'GET_GROUPS_VACANCY_REJECTED';

export const getGroupsVacansyRequested = createAction(GET_GROUPS_VACANCY_REQUESTED);
export const getGroupsVacansyReceive = createAction(GET_GROUPS_VACANCY_RECEIVED);
export const getGroupsVacansyReject = createAction(GET_GROUPS_VACANCY_REJECTED);

export const GET_VACANCY_RESPONSES_REQUESTED = 'GET_VACANCY_RESPONSES_REQUESTED';
export const GET_VACANCY_RESPONSES_RECEIVED = 'GET_VACANCY_RESPONSES_RECEIVED';
export const GET_VACANCY_RESPONSES_REJECTED = 'GET_VACANCY_RESPONSES_REJECTED';

export const getVacansyResponsesRequeste = createAction(GET_VACANCY_RESPONSES_REQUESTED);
export const getVacansyResponsesReceive = createAction(GET_VACANCY_RESPONSES_RECEIVED);
export const getVacansyResponsesReject = createAction(GET_VACANCY_RESPONSES_REJECTED);

export const POST_VIEWED_STATUS_REQUESTED = 'POST_VIEWED_STATUS_REQUESTED';
export const POST_VIEWED_STATUS_RECIVED = 'POST_VIEWED_STATUS_RECIVED';
export const POST_VIEWED_STATUS_REJECTED = 'POST_VIEWED_STATUS_REJECTED';

export const postViewedStatusRequested = createAction('POST_VIEWED_STATUS_REQUESTED');
export const postViewedStatusReceive = createAction('POST_VIEWED_STATUS_RECIVED');
export const postViewedStatusReject = createAction('POST_VIEWED_STATUS_REJECTED');

export const GET_RESPONSE_REQUESTED = 'GET_RESPONSE_REQUESTED';
export const GET_RESPONSE_RECEIVED = 'GET_RESPONSE_RECEIVED';
export const GET_RESPONSE_REJECTED = 'GET_RESPONSE_REJECTED';

export const getResponseRequeste = createAction(GET_RESPONSE_REQUESTED);
export const getResponseReceive = createAction(GET_RESPONSE_RECEIVED);
export const getResponseReject = createAction(GET_RESPONSE_REJECTED);

export const VACANCIES_REQUESTED = 'VACANCIES_REQUESTED';
export const VACANCIES_RECEIVED = 'VACANCIES_RECEIVED';
export const VACANCIES_REJECTED = 'VACANCIES_REJECTED';

export const requestVacancies = createAction(VACANCIES_REQUESTED);
export const receiveVacancies = createAction(VACANCIES_RECEIVED);
export const rejectVacancies = createAction(VACANCIES_REJECTED);

export const CHANGE_VACANCY_STATUS_REQUESTED = 'CHANGE_VACANCY_STATUS_REQUESTED';
export const CHANGE_VACANCY_STATUS_RECEIVED = 'CHANGE_VACANCY_STATUS_RECEIVED';
export const CHANGE_VACANCY_STATUS_REJECTED = 'CHANGE_VACANCY_STATUS_REJECTED';

export const requestChangeVacancyStatus = createAction(CHANGE_VACANCY_STATUS_REQUESTED);
export const receiveChangeVacancyStatus = createAction(CHANGE_VACANCY_STATUS_RECEIVED);
export const rejectChangeVacancyStatus = createAction(CHANGE_VACANCY_STATUS_REJECTED);

export const DIVISION_VACANCIES_INFO_REQUESTED = 'DIVISION_VACANCIES_INFO_REQUESTED';
export const DIVISION_VACANCIES_INFO_RECEIVED = 'DIVISION_VACANCIES_INFO_RECEIVED';
export const DIVISION_VACANCIES_INFO_REJECTED = 'DIVISION_VACANCIES_INFO_REJECTED';

export const requestDivisionVacanciesInfo = createAction(DIVISION_VACANCIES_INFO_REQUESTED);
export const receiveDivisionVacanciesInfo = createAction(DIVISION_VACANCIES_INFO_RECEIVED);
export const rejectDivisionVacanciesInfo = createAction(DIVISION_VACANCIES_INFO_REJECTED);

export const DOCUMENTS_REQUESTED = 'DOCUMENTS_REQUESTED';
export const DOCUMENTS_RECEIVED = 'DOCUMENTS_RECEIVED';
export const DOCUMENTS_REJECTED = 'DOCUMENTS_REJECTED';

export const requestDocuments = createAction(DOCUMENTS_REQUESTED);
export const receiveDocuments = createAction(DOCUMENTS_RECEIVED);
export const rejectDocuments = createAction(DOCUMENTS_REJECTED);

export const POST_DOCUMENTS_REQUESTED = 'POST_DOCUMENTS_REQUESTED';
export const POST_DOCUMENTS_RECEIVED = 'POST_DOCUMENTS_RECEIVED';
export const POST_DOCUMENTS_REJECTED = 'POST_DOCUMENTS_REJECTED';

export const requestPostDocuments = createAction(POST_DOCUMENTS_REQUESTED);
export const receivePostDocuments = createAction(POST_DOCUMENTS_RECEIVED);
export const rejectPostDocuments = createAction(POST_DOCUMENTS_REJECTED);

export const GET_CATALOG_FILTERS_REQUESTED = 'GET_CATALOG_FILTERS_REQUESTED';
export const GET_CATALOG_FILTERS_RECEIVED = 'GET_CATALOG_FILTERS_RECEIVED';
export const GET_CATALOG_FILTERS_REJECTED = 'GET_CATALOG_FILTERS_REJECTED';

export const getCatalogFiltersRequested = createAction(GET_CATALOG_FILTERS_REQUESTED);
export const getCatalogFiltersReceive = createAction(GET_CATALOG_FILTERS_RECEIVED);
export const getCatalogFiltersReject = createAction(GET_CATALOG_FILTERS_REJECTED);

export const GET_CATALOG_VACANCIES_REQUESTED = 'GET_CATALOG_VACANCIES_REQUESTED';
export const GET_CATALOG_VACANCIES_RECEIVED = 'GET_CATALOG_VACANCIES_RECEIVED';
export const GET_CATALOG_VACANCIES_REJECTED = 'GET_CATALOG_VACANCIES_REJECTED';

export const getCatalogVacanciesRequested = createAction(GET_CATALOG_VACANCIES_REQUESTED);
export const getCatalogVacanciesReceive = createAction(GET_CATALOG_VACANCIES_RECEIVED);
export const getCatalogVacanciesReject = createAction(GET_CATALOG_VACANCIES_REJECTED);
